import { render, staticRenderFns } from "./AddOrUpdateCancerTypesModal.vue?vue&type=template&id=aeefdfd2&"
import script from "./AddOrUpdateCancerTypesModal.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdateCancerTypesModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdateCancerTypesModal.vue?vue&type=style&index=0&id=aeefdfd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports